import {flatten, includes, isEmpty, uniq} from "lodash";
import {getControllerName} from "../../Utility/html";
import {pathToFullUrl} from "../../Utility/urls";

const PROD_PAGES = ['products', 'product_groups', 'categories',
  'top_categories', 'sub_categories'];

const CART_PAGES = ['shoppingCarts', 'newCheckouts', 'checkouts'];

/**
 * Select and concatenate values from profileLists config object.
 *
 * @param config
 * @param pageInfo
 * @param proactive
 * @returns {String[]}
 */
export function buildFiveNineProfileList({config, pageInfo, proactive = false}) {
  const {profileLists = {}} = config;

  const allProfiles = uniq(flatten(Object.values(profileLists)));

  let pageType = getControllerName();

  let list = null;
  if (includes(CART_PAGES, pageType)) {
    list = profileLists.cart;
  } else if (includes(PROD_PAGES, pageType)) {
    list = profileLists.product;
  }

  if (isEmpty(list)) {
    // for proactive, use the Place Order profile, as we don't let the user pick
    if (proactive) {
      list = profileLists.cart || allProfiles;
    } else {
      list = allProfiles;
    }
  }

  if (!Array.isArray(list))
    list = [list];

  return list;
}

function sharedFiveNineParams({config, pageInfo}) {
  return {
    tenant: config.tenant,
    title: config.title,
    logo: config.logoUrl ? pathToFullUrl(config.logoUrl) : '',
    theme: config.themeUrl ? pathToFullUrl(config.themeUrl) : 'default-theme.css',
  };
}

export function buildFiveNineStandardChatParams({api, config, pageInfo}) {
  let profiles = buildFiveNineProfileList({config, pageInfo});

  return Object.assign({},
    sharedFiveNineParams({api, config, pageInfo}),
    {
      type: 'chat',
      rootUrl: 'https://app.five9.com/consoles/',

      profiles: profiles,
      showProfiles: (profiles.length > 1),

      profileLabel: "How can we help you today?",

      fields: buildFiveNineFields({api, config, pageInfo})
    });
}

export function buildFiveNineProactiveChatParams({
  api, config, pageInfo
}) {
  return Object.assign({},
    sharedFiveNineParams({api, config, pageInfo}),
    {
      showProfiles: false,
      restAPI: "https://app.five9.com",
      chatConsole: "https://app.five9.com/consoles/ChatConsole/index.html",
      notificationType: "notification",
      customChatFields: buildFiveNineFields({api, config, pageInfo}),
      chatOptions: {
        allowRequestLiveAgent: false,
        showEmailButton: true,
        hideDuringAfterHours: true,
        useBusinessHours: false,
        enableCallback: false,
        callbackList: "",
        showPrintButton: false,
        playSoundOnMessage: true,
        allowCustomerToControlSoundPlay: true,
        allowUsabilityMenu: true
      }
    });
}

function buildFiveNineFields({api, config, pageInfo}) {
  return {
    question: {
      value: "",
      show: true,
      label: "How can we help you today?"
    },

    name: {
      value: "",
      show: true,
      label: "Your Name"
    },

    email: {
      value: "",
      show: true,
      label: "Email (optional)",
      required: false
    },

    /* HIDDEN fields */
    "Shopping Cart ID": {
      value: pageInfo?.cartCode,
      show: false,
      label: "Cart ID",
      required: false
    },

    CartURL: {
      value: pageInfo?.cartUrl,
      show: false,
      label: "Cart URL",
      required: false
    },

    Location: {
      value: document.location.toString(),
      show: false,
      label: "Location",
      required: false
    }
  }
}
